import { AdaptiveText, Title } from "@/components/Content";
import type { AdaptiveTextProps } from "@/components/Content/AdaptiveText";
import { Gradient } from "@/components/Gradient";
import Icon from "@/components/Icon";
import type { IconName } from "@/components/Icon";
import { cn } from "@/lib/utils";
import { Sizes } from "./Content/styles";

export interface RadiantTitleCardProps {
	iconName: IconName;
	title: string;
	text: AdaptiveTextProps["portableText"];

	className?: string;
}

export const RadiantTitleCard = ({
	iconName,
	title,
	text,

	className,
}: RadiantTitleCardProps) => {
	return (
		<div
			className={cn(
				"relative overflow-hidden rounded-lg border border-gray-200 p-6",
				className,
			)}
		>
			<Gradient className="absolute inset-0 rounded-lg" />
			<div className="absolute inset-px rounded-lg bg-white" />

			<div className="relative z-10">
				<Icon name={iconName} className="size-6 text-primary" />

				<Title as="h3" size={Sizes.Card} className="mt-4">
					{title}
				</Title>
				<AdaptiveText portableText={text} size={Sizes.Card} />
			</div>
		</div>
	);
};

export default RadiantTitleCard;
